import { render, staticRenderFns } from "./preference.vue?vue&type=template&id=08a33688"
import script from "./preference.ts?vue&type=script&lang=ts&external"
export * from "./preference.ts?vue&type=script&lang=ts&external"
import style0 from "./preference.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports